'use strict';

const submitCartForm = () => {
  window.DealEventPipe.trigger('cartFormSubmit');
};

const updateCartForm = (dealUuid, optionUuid) => {
  window.DealEventPipe.trigger('cartFormInitialize', {
    dealUuid,
    uuid: optionUuid,
  });
};

const updateAndSubmitCartForm = (dealUuid, optionUuid) => {
  updateCartForm(dealUuid, optionUuid);
  submitCartForm();
};

const getDealData = buyButtonFormEl => {
  const dealUuid = buyButtonFormEl
    .querySelector('input:checked')
    .getAttribute('data-deal');
  const optionUuid = buyButtonFormEl
    .querySelector('input:checked')
    .getAttribute('data-uuid');

  return {
    dealUuid,
    optionUuid,
  };
};

const addCartHandler = function addCartHandler(cart, isTouch = false) {
  if (!cart || !document.querySelector('#goods-add-to-cart-form')) {
    return;
  }
  const buyButtonFormEl = document.querySelector(
    '.multi-option-breakout.inline-list'
  );

  if (buyButtonFormEl) {
    this.eventPipe.on('option_clicked', () => {
      const { dealUuid, optionUuid } = getDealData(buyButtonFormEl);
      updateCartForm(dealUuid, optionUuid);
    });
    this.eventPipe.on('buy_button_clicked', event => {
      event.preventDefault();
      submitCartForm();
    });
  }

  if (isTouch) {
    const activeModalOptionEls = document.querySelectorAll(
      'ul.option-list li:not(.sold-out) a'
    );
    for (let i = 0; i < activeModalOptionEls.length; i++) {
      activeModalOptionEls[i].addEventListener('click', event => {
        event.preventDefault();
        const dealUuid = event.currentTarget.getAttribute('data-deal');
        const optionUuid = event.currentTarget.getAttribute('data-uuid');
        updateAndSubmitCartForm(dealUuid, optionUuid);
      });
    }
  }
};

module.exports = { addCartHandler, updateAndSubmitCartForm };
